import React, { FC } from "react";
import { DPPageWrapper } from "Components/DP";
import { PageNotFound } from "Components/Pages";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import { PermissionKey } from "Shared/types/Employer";

export interface DPRestrictedPageProps {
  title: string;
  onPageLoad?: () => void;
  permissionKey: PermissionKey;
}

export const DPRestrictedPage: FC<DPRestrictedPageProps> = ({
  title,
  onPageLoad,
  permissionKey,
  children,
}) => {
  const { permissions, loading } = usePartnerConfig();

  if (loading) {
    return null;
  }

  const hidePage = !permissions[permissionKey];

  return hidePage ? (
    <PageNotFound />
  ) : (
    <DPPageWrapper title={title} onPageLoad={onPageLoad}>
      {children}
    </DPPageWrapper>
  );
};

export default DPRestrictedPage;
